var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"cooking"},[_c('router-view',{staticClass:"cooking__data",attrs:{"reportDaterange":_vm.reportDaterange,"compareDaterange":_vm.compareDaterange,"userRestaurants":_vm.userRestaurants,"serviceTypes":_vm.serviceTypes}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }